import { useSearchTarget } from '@/hooks/useSearchTarget';

export const useLogic = () => {
  const { setSearchTarget } = useSearchTarget();

  const onClickStation = () => {
    setSearchTarget('station');
  };

  const onClickHospital = () => {
    setSearchTarget('hospital');
  };

  return {
    onClickStation,
    onClickHospital,
  };
};
